module.exports = __webpack_public_path__ + "media/assets/images/blog/conversational_intelligence-d98541ecb1ea1c603287e92d40e975e9.jpeg";